// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .stat-img {
  float: left;
  margin-left: 5px;
}
:host .stat-text {
  height: 100px;
  display: inline-block;
  float: left;
}
:host .stat-number {
  font-weight: bold;
  font-size: 1.2em;
  /*font-family: times;*/
}
:host img {
  /*margin-left: 1px;*/
}
:host .marginright {
  padding-right: 2px;
  /*background-color: #00ff00;*/
}
:host .marginleft {
  padding-left: 2px;
  /*background-color: #00ff00;*/
}
:host .image {
  /*background-color: #00ff00;*/
  text-align: center;
  /*margin-left: 10px;*/
}
:host table {
  background-color: white;
  padding-left: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
